export default __webpack_public_path__ + "static/media/Path 1465@2x.b2714a53.png";